import React, { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";
import { Screen } from "../components/ui-kit";
import RoleBadge from "../components/RoleBadge";

const Avatar = ({ path, picture, name }) => (
  <img src={fileUrl(path) || picture || `https://ui-avatars.com/api/?name=${encodeURIComponent(name || "?")}&background=1a1424&color=D4AF37`} alt="" className="w-16 h-16 rounded-2xl object-cover border border-white/10 shrink-0" />
);

export default function Team() {
  const [team, setTeam] = useState(null);
  useEffect(() => { api.get("/team").then((r) => setTeam(r.data)).catch(() => setTeam([])); }, []);
  return (
    <Screen>
      <div className="mb-6">
        <p className="text-[#D4AF37] text-xs uppercase tracking-[0.2em]">Community</p>
        <h1 className="font-display text-3xl font-bold">Meet the team</h1>
      </div>
      {team && team.length === 0 ? (
        <div data-testid="team-empty" className="rounded-2xl border border-white/10 bg-white/5 p-8 text-center text-[#A19DB0]">
          Our instructors and artists will appear here soon.
        </div>
      ) : (
        <div className="space-y-3">
          {(team || []).map((m, i) => (
            <div key={`${m.name}-${i}`} data-testid={`team-${i}`} className="flex gap-4 rounded-2xl border border-white/10 bg-white/5 p-4">
              <Avatar path={m.avatar_path} picture={m.picture} name={m.name} />
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap"><p className="font-display text-lg font-semibold">{m.name}</p><RoleBadge role={m.role} size="xs" /></div>
                {m.bio ? <p className="text-[#A19DB0] text-sm mt-1.5 whitespace-pre-line">{m.bio}</p> : <p className="text-[#A19DB0]/50 text-sm mt-1.5 italic">No bio yet.</p>}
              </div>
            </div>
          ))}
        </div>
      )}
    </Screen>
  );
}
